import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import styles from "./TableSelect.module.scss";
import { ReactComponent as DownArrowIcon } from "../../icons/down-arrow.svg";
import { ReactComponent as UpArrowIcon } from "../../icons/up-arrow.svg";
import { ReactComponent as CheckIcon } from "../../icons/check-thin.svg";
import OutsideClickHandler from "react-outside-click-handler";

const TableSelect = ({ value, onChange, options, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const optionsRefs = useRef([]);

  const selectedOption = options.find((option) => option.id === value);

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className={classNames(styles.wrapper, className)}>
        <div
          className={classNames(styles.select, {
            [styles.active]: selectedOption,
          })}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{selectedOption ? selectedOption.label : "Select"}</span>
          {isOpen ? (
            <UpArrowIcon className={styles.icon} />
          ) : (
            <DownArrowIcon className={styles.icon} />
          )}
        </div>
        {isOpen && (
          <div className={styles.options}>
            {options.map((option, index) => {
              const isSelected = option.id === value;
              return (
                <div
                  key={option.id || option.label}
                  ref={(el) => (optionsRefs.current[index] = el)}
                  className={classNames(styles.option, {
                    [styles.selected]: isSelected,
                  })}
                  onClick={() => {
                    setIsOpen(false);
                    onChange(option.id);
                  }}
                >
                  <span
                    className={classNames(styles.circle, {
                      [styles.low]: option.id === "low",
                      [styles.medium]: option.id === "medium",
                      [styles.high]: option.id === "high",
                    })}
                  />
                  {option.label}
                  {isSelected && <CheckIcon className={styles.checkmark} />}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default TableSelect;
